var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIIcon = function SvgIIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "i-icon_svg__a",
    d: "M12 6.667h2.667v2.666H12zM12 12h2.667v8H12zm1.333-12C5.973 0 0 5.973 0 13.333s5.973 13.334 13.333 13.334 13.334-5.974 13.334-13.334S20.693 0 13.333 0m0 24c-5.88 0-10.666-4.787-10.666-10.667S7.453 2.667 13.333 2.667 24 7.453 24 13.333 19.213 24 13.333 24"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i-icon_svg__a",
    fill: "#827127",
    fillRule: "evenodd",
    transform: "translate(.667 .667)"
  })));
};
export default SvgIIcon;